<template>
  <div class="actions-container">
      <div class="actions-box-scroll">
        <ContainerActionsBlock
          v-for="block in role_action_list"
          v-bind:key="block.id"
          v-bind:block="block.id"
          v-bind:name="block.name"
          v-bind:actions="block.action_list"
        ></ContainerActionsBlock>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ContainerActionsBlock from '@/components/containerViews/containerActionsComponents/ContainerActionsBlock'

export default {
  name: 'ContainerActions',
  components: {
    ContainerActionsBlock
  },
  data(){
    return {
      role_action_list: []
    }
  },
  computed: {
    ...mapGetters(["view_role"]),
    ...mapGetters("container",{
      container_id: 'container_id',
      container_status: 'container_status',
      action_list: 'action_list'
    }) 
  },
  mounted () {
    console.log("ROLE: " + this.view_role)
    this.filterRoleActionList()
  },
  methods: {
    filterRoleActionList(){
      for(var stageItem in this.action_list) {
        this.role_action_list.push({id: this.action_list[stageItem].id, name: this.action_list[stageItem].name, action_list: [],})
        var actionsCount = 0
        for(var actionItem in this.action_list[stageItem].action_list) {
          if((this.action_list[stageItem].action_list[actionItem].role.toUpperCase() == this.view_role.toUpperCase()) && (this.action_list[stageItem].action_list[actionItem].id!='001')){
            this.role_action_list[this.role_action_list.length-1].action_list.push(this.action_list[stageItem].action_list[actionItem])
            actionsCount ++
          }
        }
        if(actionsCount == 0) {
          this.role_action_list.pop()
        }
      }
    }
  }
}
</script>

<style lang= "scss" scoped>
.actions-container {
  position: absolute;
  width:100%;
  bottom: 30px;
  top:151px;
  display: flex;
  flex-direction: column;
}
.actions-box-scroll {
  overflow: auto;
  margin: 12px;
  flex: 1;
  border-top: 1px solid lightgray;
  padding-top: 10px;
}
</style>
